<template>
  <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
    <div class="col-12">
      <div class="bg-white q-mx-md-md">
        <div style="text-align: center; padding-top: 40px; padding-bottom: 40px">
          <img src="/assets/images/group2.svg" />
        </div>
        <div class="q-px-lg q-py-lg">
          <MainHeadline
            align="center"
            header="Your application has been sent for review"
            body="You will be notified shortly on how to proceed."
          />
        </div>
        <div class="q-px-lg q-py-lg" style="text-align: center">
          <QBtn color="primary" outline no-caps @click="onClickHandler()">{{ returnButtonLabel }}</QBtn>
        </div>
        <MoreInfoBlock />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapGetters } from 'vuex';
import MainHeadline from '@/components/Atoms/MainHeadline';
import MoreInfoBlock from '@/components/Atoms/MoreInfoBlock';
import { isScoreboardProductApplicationType } from '@/utils/calculator/scoreboardApplicationType';

export default {
  name: 'CalculatorReview',
  components: { QBtn, MainHeadline, MoreInfoBlock },
  props: [],
  computed: {
    ...mapGetters({
      vehicleApplication: 'vehicleApplication/vehicleApplication'
    }),
    isScoreboardApplication() {
      return isScoreboardProductApplicationType(this.vehicleApplication);
    },
    returnButtonLabel() {
      return this.isScoreboardApplication ? 'Return to Home' : 'Return to shortlist';
    }
  },
  created() {},
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    onClickHandler: async function () {
      this.loading = true;
      if (this.isScoreboardApplication) {
        const applicationId = this.vehicleApplication?.applicationId;
        if (applicationId) {
          try {
            await this.$router.push({ name: 'applications', params: { applicationId } });
          } catch (err) {
            if (err && err.name === 'NavigationDuplicated') {
              window.location.reload();
            } else {
              throw err;
            }
          }
        }
      } else {
        this.$router.push({ name: 'dashboard' });
      }
      this.loading = false;
    }
  }
};
</script>
